import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastService } from '../../../services/toast-service';
import { CalibrantLoadModule } from '../../shared/calibrant-load/calibrant-load.module';
import { SiteOperationsComponent } from "./site-operations.component";
import { SiteBatteryComponent } from "./site-battery/site-battery.component";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NgSelectComponent } from '@ng-select/ng-select';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatOptgroup, MatOption, MatSelect } from '@angular/material/select';


@NgModule({ declarations: [
        SiteOperationsComponent,
        SiteBatteryComponent,
    ],
  exports: [
    SiteOperationsComponent,
    SiteBatteryComponent,
  ], imports: [CommonModule,
    RouterModule,
    FontAwesomeModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    CalibrantLoadModule,
    MatExpansionModule,
    MatIconModule,
    MatTooltipModule, NgSelectComponent, MatButton, MatFormField, MatInput, MatLabel, MatSelect, MatOptgroup, MatOption], providers: [
        ToastService,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class SiteOperationsModule { }
